'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { useTranslations } from 'next-intl';
import { getUserBearerCookie } from '@/features/user/cookies/cookie-user-bearer';
import { ROUTER_LINKS } from '@/shared/constants/links-constants';
import styles from './error-page.module.scss';
interface ErrorPageProps {
  reset?: () => void;
}
export default function ErrorPage(props) {
  const $ = _c(28);
  const {
    reset
  } = props;
  const errorPageTranslations = useTranslations("page.error");
  const linksTranslations = useTranslations("global.links");
  const isUserLogged = !!getUserBearerCookie();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={styles.errorPage_image}><Image src="/images/roomster-graphics/sad-girl.svg" alt="error image" fill={true} /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== errorPageTranslations) {
    t1 = errorPageTranslations("title");
    $[1] = errorPageTranslations;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <p className={styles.errorPage_title}>{t1}</p>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== errorPageTranslations) {
    t3 = errorPageTranslations("error");
    $[5] = errorPageTranslations;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <p className={styles.errorPage_description}>{t3}</p>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== errorPageTranslations || $[10] !== reset) {
    t5 = reset && <button className={styles.errorPage_button} onClick={reset}>{errorPageTranslations("try-again")}</button>;
    $[9] = errorPageTranslations;
    $[10] = reset;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== linksTranslations) {
    t6 = linksTranslations("home");
    $[12] = linksTranslations;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t6) {
    t7 = <a className={styles.errorPage_button} href={ROUTER_LINKS.home}>{t6}</a>;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== linksTranslations) {
    t8 = linksTranslations("help");
    $[16] = linksTranslations;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t8) {
    t9 = <a className={styles.errorPage_button} href={isUserLogged ? ROUTER_LINKS.help : ROUTER_LINKS.phoneAuth}>{t8}</a>;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t5 || $[21] !== t7 || $[22] !== t9) {
    t10 = <div className={styles.errorPage_actions}>{t5}{t7}{t9}</div>;
    $[20] = t5;
    $[21] = t7;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t10 || $[25] !== t2 || $[26] !== t4) {
    t11 = <div className={styles.errorPage}><div className={styles.errorPage_content}>{t0}<div className={styles.errorPage_info}>{t2}{t4}{t10}</div></div></div>;
    $[24] = t10;
    $[25] = t2;
    $[26] = t4;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  return t11;
}